import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import Image from '../common/Image';
import GlobalConfig from '../../lib/GlobalConfig';
const NextButton = (props) => {
    const { clickHandler, isEndReached } = props;
    return (_jsx("button", { className: clsx('iv-absolute', 'iv-backdrop-blur-[30px]', 'iv-rounded-30', 'iv-top-1/2', 'iv--translate-y-2/4', 'iv-right-[40px]', 'iv-px-25 iv-py-15', 'iv-bg-black-70 hover:iv-bg-grey-100 iv-transition', isEndReached && 'iv-hidden'), onClick: clickHandler, children: _jsx("div", { className: "iv-flex", children: _jsx(Image, { src: `${GlobalConfig.cdn.SHARED_URL}/icons/next-arrow.svg`, width: 28, height: 17, alt: "next-button", loading: "lazy" }) }) }));
};
export default NextButton;
